export class PROD {
    Type: string = "PROD";
    SerialNumber: string;
    ProdDataInici: Date;
    ProdDataFi: Date;
    Quantity: number;
    Side: number;
    TotalPiecesNG: number;
}